// Код отказа синхронизации для отчётов в Hawk и PostHog.
//
// Инцидент 2026-09-19/20: `studyhub-powersync` упал в 19:17 UTC (диск хоста
// кончился, повторный запуск не смог примонтировать слой) и пролежал 14 часов.
// Caddy всё это время отдавал 502, вкладки исправно докладывали о невосстановлении
// — и в Hawk отчёт приезжал с `sync_error_code: "HTTP :"`, то есть без единого
// признака того, что сервис лежит. Отличить полный отказ прода от известного
// шума (`PSYNC_S2103 JWT has expired`) было нечем: обе половины падали в одну
// группу `powersync.sync_error`, помеченную «решено» ещё в августе.
//
// Числовой статус при этом никуда не пропадал: SDK
// (`@powersync/shared-internals`, `AbstractRemote`) собирает текст как
// `HTTP ${res.statusText}: ${text}` и ОТДЕЛЬНО кладёт `error.status =
// res.status`. `statusText` по HTTP/2 пуст всегда (это свойство протокола, а не
// нашей конфигурации), тело 502 от Caddy тоже пустое — поэтому весь смысл
// ошибки живёт в поле, которое мы не читали.

/** Числовой HTTP-статус отказа, если SDK его приложил. */
export function httpStatusFromSyncError(error: unknown): number | null {
	if (!error || typeof error !== "object") return null;
	const status = (error as { status?: unknown }).status;
	if (typeof status !== "number" || !Number.isInteger(status)) return null;
	if (status < 100 || status > 599) return null;
	return status;
}

const EMPTY_HTTP_PREFIX = /^HTTP\s*[^:]*:\s*/;

/**
 * Текст отказа для отчёта: тот же, что отдал SDK, но с восстановленным
 * числовым статусом вместо пустого `statusText`.
 */
export function syncErrorCodeFrom(error: Error | undefined | null): string | null {
	if (!error) return null;
	const status = httpStatusFromSyncError(error);
	// SDK иногда отдаёт в `downloadError` не `Error`, а строку или объект без
	// `message` (аварийный разрыв стрима) — вызов `.trim()` на `undefined` ронял
	// рендер дашборда в route-error-component (Hawk: «reading 'trim'»).
	const message = typeof error.message === "string" ? error.message.trim() : "";
	if (!message) return status === null ? "unknown" : `HTTP ${status}`;
	if (status === null) return message.slice(0, 120);
	const rest = message.replace(EMPTY_HTTP_PREFIX, "").trim();
	const restored = rest ? `HTTP ${status}: ${rest}` : `HTTP ${status}`;
	return restored.slice(0, 120);
}

/**
 * Заголовок события Hawk. Статус входит в заголовок намеренно: Hawk группирует
 * по нему, и без этого лежащий сервис (502) копится в одной группе с протухшим
 * токеном вкладки (401), а вердикт по группе достаётся обоим.
 */
export function syncErrorEventTitle(status: number | null): string {
	return status === null ? "powersync.sync_error" : `powersync.sync_error: HTTP ${status}`;
}
